module.exports = require("when");


//////////////////
// WEBPACK FOOTER
// external "when"
// module id = 2
// module chunks = 0